export default __webpack_public_path__ + "static/media/space-desert.b7284888875c19ccd4cd205ea3057d2f.svg";